module.exports = __webpack_public_path__ + "static/bg-highlight-home-mobile-d1895bc45756a76363d99d52503ea660.png";